$(function() {
  const $window = $(window);

  function initSlider() {
    const $featuredProductsSlider = $('.js-featured-products-slider');

    $featuredProductsSlider.slick({
      autoplay: true,
      speed: 1000,
      slidesToShow: 4,
      pauseOnHover: false,
      slidesToScroll: 4,
      prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
      nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>',
      responsive: [
        {
          breakpoint: 584,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }
      ]
    });
  }

  initSlider();
});
